// extracted by mini-css-extract-plugin
export default {"price":"ProductDetail_price__HpN-a","link":"ProductDetail_link__j1H-R","theme-grayscale":"ProductDetail_theme-grayscale__htYGF","points":"ProductDetail_points__YoWx0"};